import Vue from 'vue'
import App from './App.vue'
import i18n from "./i18n"; // 引入 i18n 配置
Vue.config.productionTip = false

// 导入route.js的route对象
import index from './router/index.js'
import 'amfe-flexible'
new Vue({
  render: h => h(App),
  i18n,
  router:index //相当于 router: router,当对象名称与对象值同名时，可以这么简写
}).$mount('#app')